import ky from "ky";

import type { Metadata } from "@solvari/argus";

import { getEnv, handleQuery } from "@solvari/utils";

type Application = {
  uuid: string;
};

type FormData = {
  description: string;
  email: string;
  firstName: string;
  isSubscribedToNewsletter: boolean;
  lastName: string;
  subject: string;
};

type SubmitData = Application & FormData & Metadata;

const submit = {
  mutation: handleQuery((submitData: SubmitData) => {
    const url = `${getEnv().network.api}/v4/client/contact-form-submission`;
    return ky
      .post(url, {
        json: {
          ...submitData,
          isSubscribedToNewsletter: submitData.isSubscribedToNewsletter ? 1 : 0,
        },
      })
      .json<{ uuid: string }>();
  }),
};

export { submit };
